<h1 mat-dialog-title>Are you sure you want to switch company?</h1>


	<div mat-dialog-content fxLayout="column" fxAlign="center center">
		<div class="height-auto">
			<div fxLayout="column" fxLayoutGap="20px">


        <div fxLayout="row" fxLayoutGap="20px">
          <button fxFlex mat-button (click)="dialogRef.close('cancel')" type="button"> {{ 'LABEL_CANCEL' | translate }} </button>
          <button color="primary" fxFlex mat-raised-button  (click)="dialogRef.close('confirm')">Confirm</button>
        </div>
			</div>
		</div>
	</div>